export default {
	title: 'Sensor',
	selectAll: 'Select All',
	selectedCount: 'Selected {count} items',
	batchDelete: 'Batch Delete',
	batchDeleteWithCount: 'Batch Delete ({count})',
	noData: {
		title: 'No Sensor Data',
		description: 'No sensor data found'
	},
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		diagnose: 'Diagnose',
		setOffset: 'Set Offset',
		triggerAlarm: 'Trigger Alarm',
		uploadWaveform: 'Upload Waveform',
		algorithmModelConfig: 'Algorithm Model Config',
		warnLevelLimit: 'Upper limit of alarm level',
		refreshAlgorithmModel: 'Refresh Algorithm Model',
		oneKeyTest: 'One-Key Test'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Delete successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		selectSensorWarning: 'Please select sensor',
		selectFileRequired: 'Please select files to upload',
		uploadSuccess: 'Upload successful',
		uploadFailed: 'Upload failed',
		alarmTimeRequired: 'Please select start time and end time',
		alarmTimeInvalid: 'Start time must be earlier than end time',
		alarmTriggerSuccess: 'Alarm triggered successfully',
		confirmRefreshAlgorithmModel: 'Are you sure you want to refresh the algorithm model? This will regenerate the model configuration.',
		confirmRefresh: 'Confirm Refresh',
		refreshAlgorithmModelSuccess: 'Algorithm model refreshed successfully',
		fileSizeExceeded: 'File size cannot exceed {size}MB',
		fileTypeNotSupported: 'Only {type} format files are supported',
		confirmTrigger: 'Confirm Trigger',
		pleaseSelectAlgorithmModelGroup: 'Please select algorithm model group',
		pleaseSelectWarnLevelLimit: 'Please select upper limit of alarm level',
		configSuccess: 'Configuration successful',
		paramNamePlaceholder: 'Please enter parameter name',
		delete: 'Delete',
		addRow: '+ Add Row'
	},
	form: {
		projNo: 'Project',
		name: 'Measurement Point Name',
		pointNo: 'Measurement Point Number',
		deviceName: 'Device Name',
		model: 'Model',
		orgId: 'Organization (Diagnosis)',
		deviceId: 'Device',
		direction: 'Installation Direction',
		axisCount: 'Axis Count',
		typeId: 'Point Type',
		pointType: 'Business Type',
		cylinderId: 'Select Cylinder',
		sort: 'Sort',
		sensorImage: 'Sensor Image',
		diagnoseGroupCode: 'Algorithm Model Group',
		warnLevelLimit: 'Upper Limit of Alarm Level',
		configOffLineTime: 'Offline Time (minutes)',
		placeholder: {
			projNo: 'Please select project',
			name: 'Please enter measurement point name',
			pointNo: 'Please enter measurement point number',
			deviceName: 'Please enter device name',
			model: 'Please enter model',
			orgId: 'Please select organization (diagnosis)',
			deviceId: 'Please select device',
			direction: 'Please select installation direction',
						axisCount: 'Please enter axis count',
			typeId: 'Please select point type',
			pointType: 'Please select business type',
			cylinderId: 'Please select cylinder',
			sort: 'Please enter sort',
			diagnoseGroupCode: 'Please select algorithm model group',
			configOffLineTime: 'Please enter offline time'
		}
	},
	table: {
		name: 'Measurement Point Name',
		pointNo: 'Measurement Point Number',
		deviceName: 'Device Name',
		typeId: 'Type',
		pointTypeName: 'Business Type',
		power: 'Power',
		direction: 'Installation Direction',
		sensorStatus: 'Sensor Status',
		onlineStatus: 'Communication Status',
		model: 'Model',
		orgPath: 'Path',
		diagnoseGroupCode: 'Algorithm Model Group'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm',
		close: 'Close',
		uploadWaveformTitle: 'Upload Waveform File',
		alarmTimeRangeTitle: 'Select Alarm Time Range',
		algorithmModelConfigTitle: 'Algorithm Model Config',
		warnLevelLimitConfigTitle: 'Alarm Level Upper Limit Setting',
		selectedSensor: 'Selected Sensor',
		testResultTitle: 'Test Result'
	},
	warnLevel: {
		general: 'General',
		medium: 'Medium',
		serious: 'Serious'
	},
	upload: {
		selectFile: 'Select File',
		dragTip: 'Drag files here, or',
		clickUpload: 'click to upload',
		tip: 'Support multiple files upload, maximum 200 files, each file maximum {size}MB',
		upload: 'Upload'
	},
	alarm: {
		startTime: 'Start Time',
		endTime: 'End Time',
		pleaseSelectStartTime: 'Select Start Time',
		pleaseSelectEndTime: 'Select End Time'
	},
	offset: {
		title: 'Set Offset',
		paramName: 'Parameter Name',
		paramNamePlaceholder: 'Please enter parameter name',
		delete: 'Delete',
		addRow: '+ Add Row',
		columns: {
			ZA: 'Z-A',
			ZB: 'Z-B',
			XA: 'X-A',
			XB: 'X-B',
			YA: 'Y-A',
			YB: 'Y-B'
		}
	},
	testResult: {
		selectedPoints: 'Selected Points',
		testingSubtitle: 'Checking point feature status, please wait...',
		doneSubtitle: 'Feature status check completed for {count} points',
		loadingTip1: 'Sending test command...',
		loadingTip2: 'Collecting point feature status...',
		loadingTip3: 'Summarizing test results...',
		retest: 'Retest',
		copyJson: 'Copy JSON',
		export: 'Export CSV',
		done: 'Test Completed',
		testTime: 'Test Time',
		totalCount: 'Total Points',
		online: 'Online',
		offline: 'Offline',
		status: 'Status',
		lastTime: 'Last Time',
		emptyResult: 'No test results obtained',
		failed: 'Test failed, please try again later',
		copySuccess: 'Copied successfully',
		exportSuccess: 'Exported successfully'
	}
}
